module.exports = __webpack_public_path__ + "static/img/design-1.281ca4e7.png";